package tools

import androidx.compose.runtime.*
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.LocalTime
import kotlinx.datetime.format
import kotlinx.datetime.format.*
import ssoft.frontend.generated.resources.*

@OptIn(FormatStringsInDatetimeFormats::class)
@Composable
fun LocalDate.formatFromRes(): String {
    var result by remember {
        mutableStateOf("")
    }
    LaunchedEffect(this) {
        val formatLine = Res.string.global_format_date_numbers.await()
        result = format(LocalDate.Format {
            byUnicodePattern(formatLine)
        })
    }
    return result
}

@OptIn(FormatStringsInDatetimeFormats::class)
@Composable
fun LocalTime.formatFromRes(): String {
    var result by remember {
        mutableStateOf("")
    }
    LaunchedEffect(this) {
        val formatLine = Res.string.global_format_time_numbers.await()
        result = format(LocalTime.Format {
            byUnicodePattern(formatLine)
        })
    }
    return result
}

@OptIn(FormatStringsInDatetimeFormats::class)
@Composable
fun LocalDateTime.formatFromRes(): String {
    var result by remember {
        mutableStateOf("")
    }
    LaunchedEffect(this) {
        result = formatFromResAwait()
    }
    return result
}

@OptIn(FormatStringsInDatetimeFormats::class)
suspend fun LocalDateTime.formatFromResAwait(): String {
    val formatLine = Res.string.global_format_date_time_numbers.await()
    return format(LocalDateTime.Format {
        byUnicodePattern(formatLine)
    })
}

suspend fun LocalDate.Companion.formatter(withYear: Boolean = true): DateTimeFormat<LocalDate> {
    val monthNames = Res.string.global_months_short.await()
        .split(",")
        .let { MonthNames(it) }
    val formatter = Format {
        if (withYear) {
            year()
            char(' ')
        }
        monthName(monthNames)
        char(' ')
        dayOfMonth()
        char('.')
    }
    return formatter
}

@Composable
fun LocalDate.niceFormat(withYear: Boolean = true): String {
    var result by remember(this) { mutableStateOf("") }

    LaunchedEffect(this) {
        result = format(LocalDate.formatter(withYear))
    }
    return result
}

@Composable
fun LocalDateTime.niceFormat(): String {
    var result by remember { mutableStateOf("") }

    LaunchedEffect(this) {
        val monthNames = Res.string.global_months_short.await()
            .split(",")
            .let { MonthNames(it) }
        val formatter = LocalDateTime.Format {
            year()
            char(' ')
            monthName(monthNames)
            char(' ')
            dayOfMonth()
            chars(". ")
            hour()
            char(':')
            minute()
        }
        result = format(formatter)
    }
    return result
}
